module.exports = __webpack_public_path__ + "static/img/zhishiku.af6ec8ad.png";